<template>
  <div class="logo">
    <a
      :href="usertype === USER_TYPE.AIRPORT ? '#airportmap' : '#/dashboard'"
      class=""
    >
      <div class="logo-imgs">
        <img :src="logo" alt="Logo" />
      </div>
    </a>
    <div class="simple-text logo-normal" style="padding-left: 10%;">
      <span style="font-size: small; ">{{
        (company && company.length) > 20 ? company.substring(0, 20) : company
      }}</span>
      <span class="break" />
      <span style="font-size: small; ">{{ firstname }}</span>
      <span class="break" />
      <span style="font-size: small; "> {{ usertype }}</span>
    </div>
    <div class="navbar-minimize">
      <md-button
        id="minimizeSidebar"
        class="md-round md-just-icon md-transparent"
        @click="minimizeSidebar"
      >
        <i class="material-icons text_align-center visible-on-sidebar-regular"
          >more_vert</i
        >
        <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini"
          >view_list</i
        >
      </md-button>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { USER_TYPE } from "@/const";

export default {
  props: {
    logo: {
      type: String,
      default: "./img/rpas_logo.png"
    },
    avatar: {
      type: String,
      default: "./img/map.png"
    }
  },
  data() {
    return {
      USER_TYPE,
      isClosed: false
    };
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  computed: {
    ...mapFields("auth", ["firstname", "usertype", "company"])
  }
};
</script>

<style>
.break {
  display: block;
  margin-bottom: -15px;
}
</style>
